import { render } from "./GeneralList.vue?vue&type=template&id=21bcf7e0&scoped=true"
import script from "./GeneralList.vue?vue&type=script&lang=js"
export * from "./GeneralList.vue?vue&type=script&lang=js"

import "./GeneralList.vue?vue&type=style&index=0&id=21bcf7e0&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bcf7e0"]])

export default __exports__